(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["wc-bb-supply"] && !Shopify.designMode) return;
  try {
    function wcSupplyUpdateQty(btn, section) {
    var qty = parseInt(btn.dataset.supplyQty, 10);
    if (isNaN(qty) || qty < 1) return;

    var qtyInput = section.querySelector('input[name="quantity"]');
    if (qtyInput) {
      qtyInput.value = qty;
      qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
    } else {
      var form = section.querySelector('form[data-type="add-to-cart-form"]');
      if (form) {
        var hidden = form.querySelector('input[data-wc-supply-qty]');
        if (!hidden) {
          hidden = document.createElement('input');
          hidden.type = 'hidden';
          hidden.name = 'quantity';
          hidden.setAttribute('data-wc-supply-qty', '');
          form.appendChild(hidden);
        }
        hidden.value = qty;
      }
    }

    var productForm = section.querySelector('product-form-component');
    if (productForm) productForm.dataset.quantityDefault = qty;
  }

  function wcSupplyUpdateMeta(btn, section) {
    var priceEl = section.querySelector('[data-variant-price]');
    var compareEl = section.querySelector('[data-variant-compare-price]');
    var saveEl = section.querySelector('[data-variant-save]');

    var formattedPrice = btn.dataset.supplyPrice;
    var hasCompare = btn.dataset.supplyHasCompare === 'true';
    var formattedCompare = btn.dataset.supplyComparePrice;
    var saveText = btn.dataset.supplySave;

    if (priceEl && formattedPrice) priceEl.textContent = formattedPrice;

    if (compareEl) {
      if (hasCompare && formattedCompare) {
        compareEl.textContent = formattedCompare;
        compareEl.style.display = '';
      } else {
        compareEl.style.display = 'none';
      }
    }

    if (saveEl) {
      if (hasCompare && saveText) {
        saveEl.textContent = saveText;
        saveEl.style.display = '';
      } else {
        saveEl.style.display = 'none';
      }
    }
  }

  document.querySelectorAll('[data-supply-option]').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var section = this.closest('.wc-bb');
      if (!section) return;
      section.querySelectorAll('[data-supply-option]').forEach(function(b) {
        b.classList.remove('wc-bb-supply--selected');
      });
      this.classList.add('wc-bb-supply--selected');
      wcSupplyUpdateQty(this, section);
      wcSupplyUpdateMeta(this, section);
    });
  });

  document.querySelectorAll('[data-supply-option].wc-bb-supply--selected').forEach(function(btn) {
    var section = btn.closest('.wc-bb');
    if (section) {
      wcSupplyUpdateQty(btn, section);
      wcSupplyUpdateMeta(btn, section);
    }
  });
  } catch(e) { console.error(e); }
})();

})();
